import { render, staticRenderFns } from "./DashboardLink.vue?vue&type=template&id=68e21464&scoped=true&"
import script from "./DashboardLink.vue?vue&type=script&lang=ts&"
export * from "./DashboardLink.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardLink.vue?vue&type=style&index=0&id=68e21464&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e21464",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
